import { Component } from 'react';

import ModuleTitleFrame from '../frames/ModuleTitleFrame';
import ModuleTitleLink from './ModuleTitleLink';
import ModuleTitleMain from './ModuleTitleMain';

interface IProps {
  titleText: string;
  linkText?: string;
  linkURL?: string;
  dataClParams?: string;
  linkTargetBlank: boolean; // リンクを別タブで開く場合
  hasPayPay: boolean;
  narrowPaddingBottom: boolean;
}

interface IDefaultProps {
  linkTargetBlank: boolean;
  narrowPaddingBottom: boolean;
}

export default class ModuleTitle extends Component<IProps> {
  public static defaultProps: IDefaultProps = {
    linkTargetBlank: false,
    narrowPaddingBottom: false
  };
  /**
   *
   */
  public render() {
    return (
      <ModuleTitleFrame narrowPaddingBottom={this.props.narrowPaddingBottom}>
        <ModuleTitleMain titleText={this.props.titleText} hasPayPay={this.props.hasPayPay} />
        {this.props.linkText && this.props.linkURL && this.props.dataClParams ? (
          <ModuleTitleLink
            linkText={this.props.linkText}
            linkURL={this.props.linkURL}
            dataClParams={this.props.dataClParams}
            linkTargetBlank={this.props.linkTargetBlank}
          />
        ) : null}
      </ModuleTitleFrame>
    );
  }
}
